'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (series, dashboard) {
    var fontSize = dashboard ? DASHBOARD_FONT_SIZE : DEFAULT_FONT_SIZE;

    return [{
        name: series[0].name,
        data: series[0].data.slice(0, 1),
        enableMouseTracking: false,
        dataLabels: {
            y: 0,
            borderWidth: 0,
            verticalAlign: 'bottom',
            style: {
                fontSize: fontSize
            }
        }
    }];
};

var DEFAULT_FONT_SIZE = '34px';

var DASHBOARD_FONT_SIZE = '24px';
//# sourceMappingURL=gauge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/series/gauge.js
 ** module id = 206
 ** module chunks = 0 1
 **/